<div class="row">
    <div class="col-12" style="margin-top: 100px;">

    </div>
</div>

<section class="" *ngIf="planFeatures">
    <div class="container-xl">
        <div class="row mt-2 justify-content-center">
            <!-- <h3 class="custom-text text-center" *ngIf="planFeatures.data.discount_text">
                {{planFeatures.data.discount_text}}
            </h3> -->

            <h2 class="text-center dark mb-3 underline">
                {{planFeatures.data.plan_name}}
            </h2>
            <div class="col-md-4 card-fit">
                <div class="card">
                    <div class="card-header card-header-first">
                        <div class="row mt-3">
                            <div class="col-8">
                                <p>Standard Plan</p>
                            </div>
                            <div class="col-4">
                                <ng-container *ngIf="planFeatures.standard.original_price != planFeatures.standard.price">
                                    <p class="text">AED {{planFeatures.standard.original_price}}</p>
                                </ng-container>
                                <ng-container *ngIf="planFeatures.standard.original_price == planFeatures.standard.price">
                                    <p class="text">AED {{planFeatures.standard.price}}</p>
                                </ng-container>
                                <!-- <p class="word">+5% VAT</p> -->
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row" *ngFor="let pf of planFeatures.standard.features">
                            <div class="col-9">
                                <p class="bold list" *ngIf="!pf.label2">
                                    {{pf.label ? pf.label : "&nbsp;"}}
                                </p>
                                <p *ngIf="pf.label2" [innerHTML]="pf.label2"></p>
                            </div>
                            <div class="col-3 text-end">
                                <p class="bold list" *ngIf="pf.value">
                                    {{pf.value}}
                                </p>
                                <i  *ngIf="pf.label && !pf.value" class="fa fa-check icon"></i>
                            </div>
                        </div>
                 
                        <div class="text-center">
                            <button type="button" class="btn subscribe" (click)="onSubmit(planFeatures.standard)">Subscribe</button>
                        </div>                        
                    </div>
                </div>
            </div>
            <div class="col-md-4 card-fit mb-5">
                <div class="card">
                    <div class="card-header head">
                        <div class="row mt-3">
                            <div class="col-8">
                                <p>Premium Plan</p>
                            </div>
                            <div class="col-4">
                                <ng-container *ngIf="planFeatures.premium.original_price != planFeatures.premium.price">
                                    <p class="text">AED {{planFeatures.premium.original_price}}</p>
                                </ng-container>
                                <ng-container *ngIf="planFeatures.premium.original_price == planFeatures.premium.price">
                                    <p class="text">AED {{planFeatures.premium.price}}</p>
                                </ng-container>
                                <!-- <p class="word">+5% VAT</p> -->
                            </div>
                        </div>
                    </div>
                
                    <div class="card-body">
                        <div class="row" *ngFor="let pf of planFeatures.premium.features">
                            <div class="col-9">
                                <p class="bold list">{{pf.label}}</p>
                            </div>
                            <div class="col-3 text-end">
                                <p class="bold list" *ngIf="pf.value">
                                    {{pf.value}}
                                </p>
                                <i  *ngIf="!pf.value" class="fa fa-check icon"></i>
                            </div>
                        </div>
                       
                        <div class="text-center">
                            <button type="button" class="btn subscribe-select" (click)="onSubmit(planFeatures.premium)">Subscribe</button>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="modal fade" id="discountModal" tabindex="-1" 
    data-backdrop="static" data-keyboard="false" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="discountModalLabel">
                    Enter Discount Code
                </h1>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <div>
                    <input type="text" class="form-control" placeholder="Enter discount code" [(ngModel)]="discountCode">
                </div>
                <span *ngIf="discountErrorMessage" class="text-danger">
                    {{discountErrorMessage}}
                </span>
                
                <button class="btn w-100 subscribe-select mt-2" (click)="applyDiscount()">Apply</button>
                
                <div class="mt-2 text-end">
                    <a href="javascript:void(0);" class="text-decoration-none" 
                       style="color: #5a5757;" (click)="proceedWithoutCoupon()">
                        Proceed without coupon code
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

